import {appendAll} from "../utils/helpers";

const LAMAccessoryGallery = () => {
  const liquidData = JSON.parse(
    document.getElementById(`lam-accessory-gallery-metafields`).textContent
  );

  appendAll(liquidData);
}

export default LAMAccessoryGallery;